// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const signisplayColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#00B7F2',
  secondary: '#00B7F2',
}

export const darkTheme = {
  colors: signisplayColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: signisplayColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: signisplayColors.primaryGray,
    secondary: signisplayColors.secondaryGray,
    disabled: signisplayColors.grayText,
    link: signisplayColors.secondaryGray,
    hint: signisplayColors.white,
    highlight: signisplayColors.secondary,
    gray: signisplayColors.primaryGray,
    seeAll: signisplayColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: signisplayColors.primaryGray,
    gray: signisplayColors.secondaryGray,
  },
  filter: {
    primary: signisplayColors.primaryGray,
    secondary: signisplayColors.secondaryGray,
    disabled: signisplayColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: signisplayColors.dark,
    color: signisplayColors.white,
    border: signisplayColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: signisplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: signisplayColors.dark,
        selected: signisplayColors.dark,
        progress: rgba(signisplayColors.primary, 0.3),
        past: rgba(signisplayColors.primary, 0.3),
        pastSelected: signisplayColors.dark,
        pastHover: signisplayColors.dark,
        empty: '#555555',
        emptyProgress: rgba(signisplayColors.primary, 0.1),
      },
      text: {
        empty: signisplayColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: signisplayColors.white,
    subTitle: signisplayColors.secondaryGray,
    bg: signisplayColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 160,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
